import { fetchAndActivate, getValue } from "firebase/remote-config";
import { remoteConfig } from "../firebase/firebase";

let remoteConfigPromise;

const parseJson = (value, fallback) => {
  if (!value) {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const getString = (key) => getValue(remoteConfig, key).asString();
const getBoolean = (key) => getValue(remoteConfig, key).asBoolean();
const getNumber = (key) => getValue(remoteConfig, key).asNumber();
const getJson = (key, fallback) => parseJson(getString(key), fallback);

const getRemoteConfigValueByType = (key, type = "string", fallback = null) => {
  switch (type) {
    case "boolean":
      return getBoolean(key);
    case "number":
      return getNumber(key);
    case "json":
      return getJson(key, fallback);
    case "string":
    default:
      return getString(key) || fallback;
  }
};

const readRemoteConfigValues = () => ({
  ...getJson("nbKycFlowStaticData", {}),
});

const fetchRemoteConfig = async () => {
  if (!remoteConfigPromise) {
    remoteConfigPromise = fetchAndActivate(remoteConfig)
      .then(() => {
        return readRemoteConfigValues();
      })
      .catch((error) => {
        remoteConfigPromise = null;
        throw error;
      });
  }

  return remoteConfigPromise;
};

const fetchRemoteConfigValue = async (
  key,
  type = "string",
  fallback = null,
) => {
  await fetchRemoteConfig();

  return getRemoteConfigValueByType(key, type, fallback);
};

export { fetchRemoteConfig, fetchRemoteConfigValue, readRemoteConfigValues };
